<template>
  <BuilderWrapper
    data-test="bubble-levels-settings-wrapper"
    title="Levels Display Settings"
  >
    <div
      v-for="level in levelsHelper.levels"
      :key="level.column"
      data-test="checkbox-list"
      class="flex-grow-1 ml-4 d-flex align-items-center"
      :title="bubblesExplanation(level.level)"
    >
      <b-checkbox
        :checked="level.showBubbles || level.level === levelsHelper.maxLevel"
        :disabled="showBubblesDisabled(level.level)"
        :data-test="`checkbox-level-${level.level}`"
        style="white-space: nowrap;"
        @input="toggle(level.column, $event)"
      >
        Level {{ level.level }}: {{ level.name || level.column }}
      </b-checkbox>
    </div>
  </BuilderWrapper>
</template>

<script lang="ts">

import Component from 'vue-class-component'
import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import BubblesLevelsMixin from '@/mixins/BubblesLevelsMixin'

const components = {
  BuilderWrapper,
}

@Component({ components })
export default class BubbleLevelsSettings extends BubblesLevelsMixin {
  toggle (column: string, state: Boolean) {
    this.$typedStore.primary.app.updateFieldConfig({
      column,
      partialValue: {
        showBubbles: state,
      },
    })
  }

  get levelsHelper () {
    return this.$typedStore.primary.app.levels
  }
}

</script>
